import { render, staticRenderFns } from "./widget_chat_session_success.vue?vue&type=template&id=88e2ed4c&"
import script from "./widget_chat_session_success.vue?vue&type=script&lang=js&"
export * from "./widget_chat_session_success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports